// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jc-0";